module.exports = __webpack_public_path__ + "static/media/profile_share.3c7dac6e.svg";